import { render } from "./TuChoiLenh.vue?vue&type=template&id=73863b86"
import script from "./TuChoiLenh.vue?vue&type=script&lang=js"
export * from "./TuChoiLenh.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__